import React from 'react';

/**
 * The edit surface for a legacy container block: the view, plus a line saying
 * why it cannot be edited.
 *
 * These blocks exist on six pre-archive pages and nowhere else. We register no
 * schema and no sidebar for them because nobody authors container blocks in
 * this archive -- but Volto's edit form looks up `blocksConfig[type].edit`
 * unconditionally, so leaving it out would crash the CMS-UI on exactly those
 * six pages. This is the smallest thing that keeps the editor working and
 * still tells the truth about what is editable.
 */
const readOnlyEdit = (View) => {
  const ReadOnlyEdit = (props) => (
    <div className="archives-legacy-block-edit">
      <p className="archives-legacy-block-edit__note">
        Legacy block, shown read-only. Its content is preserved exactly as it
        was authored on the previous site and cannot be changed here.
      </p>
      <View {...props} />
    </div>
  );
  ReadOnlyEdit.displayName = `ReadOnlyEdit(${View.displayName || View.name || 'View'})`;
  return ReadOnlyEdit;
};

export default readOnlyEdit;
